export const slugName = (name = '') =>
  String(name)
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'ITEM';

export const encodeBarcodePrice = (price) => {
  const wholesale = Math.round(Number(price) || 0);
  return `111${wholesale}000`;
};

export const decodeBarcodePrice = (encoded) => {
  const raw = String(encoded || '').trim();
  const masked = raw.match(/^111(\d+)000$/);
  if (masked) return Number(masked[1]);
  return Number(raw) || 0;
};

export const buildBarcodeValue = ({ productName, size, color, wholesalePrice }) => {
  const sizeCode = String(size || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '');
  const colorCode = String(color || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  const parts = ['PROD', slugName(productName), sizeCode];
  if (colorCode) parts.push(colorCode);
  parts.push(encodeBarcodePrice(wholesalePrice));
  return parts.join('-');
};

export const isValidBarcodeValue = (code = '') =>
  /^PROD-[A-Z0-9]+(?:-[A-Z0-9]+)*-\d+$/.test(String(code).trim().toUpperCase());

export const normalizeBarcodeValue = (code = '') => String(code).trim().toUpperCase();
